module.exports = __webpack_public_path__ + "img/ennetix-xtend-processes-table.0c12103d.png";